import axios from 'axios';
// axios.defaults.withCredentials=true;
import Qs from 'qs'
// http请求
import { Message } from 'element-ui';

function apiAxios(api, url, params, response, stuts) {
  if (stuts) {
    var http = axios.create({
      baseURL: '',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        // data = Qs.stringify(data);
        data = JSON.stringify(data);
        return data;
      }],
    });
  } else {
    var info = localStorage.getItem('userInfo');
    if (info) {
      var user = JSON.parse(info);
      var token = user.token;
    };
    var http = axios.create({
      baseURL: '',
      withCredentials: true,
      headers: {
        'Content-Type': api.headers ? 'application/x-www-form-urlencoded' : 'application/json;charset=utf-8',
        'Authorization': 'Bearer ' + token,
      },
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        // data = Qs.stringify(data);
        if (api.headers && api.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
          data = Qs.stringify(data); // form-urlencoded格式
        } else {
          data = JSON.stringify(data); // 默认JSON格式
        }
        return data;
      }],
    });
  }
  http({
    method: api.method,
    url: url,
    data: api.method === 'POST' || api.method === 'PUT' ? params : null,
    params: api.method === 'GET' || api.method === 'DELETE' ? params : null,
  }).then(function (res) {
    if (res.status >= 200 && res.status < 300) {
      if (res.data.code == '10000') {
        var test = window.location.pathname;
        if (test !== '/login') {
          localStorage.removeItem('userInfo');
          location.href = '/login'
        }
      }
      
      if(res.data.code == '-1'){
        Message.closeAll()
        Message.error(res.data.msg);
      }
      response(res.data);
    }
  }).catch(function (err) {
    console.error(err);
  })
}

export default {
  axiosFun: function (api, params, response, stuts) {
    return apiAxios(api, api['url'], params, response, stuts);
  }
}



// WEBPACK FOOTER //
// ./src/common/http.js